module.exports = __webpack_public_path__ + "img/satelites.bddbdee5.jpg";